import { Files } from '../../lib/constants/files'
import { TripBookingDocument } from '../../lib/types/models/trip-booking/trip-booking-document'
import { TripBookingDocumentInput } from '../../lib/types/models/trip-booking/trip-booking-document-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateTripBookingDocument(
  input: TripBookingDocumentInput & { id: number; tripBookingId: number }
) {
  const { id, tripBookingId, ...data } = input

  if (data.file) {
    const file = await uploadFile(Files.TRIP_BOOKING_DOCUMENT, data.file)
    if (!file) throw new Error('File not uploaded')
    data.file = file
  }

  return restApiClient
    .url(
      constructApiUrl(API['trip-bookings'].updateDocument.url, {
        id: tripBookingId,
        documentId: id
      })
    )
    .patch<TripBookingDocument, TripBookingDocumentInput>(data)
}
